import {AnyAction, applyMiddleware, compose, createStore, Reducer, Store} from 'redux';
import createSagaMiddleware, {SagaMiddleware} from '@redux-saga/core';
import {createReduxPromiseListener, PromiseListener} from './PromiseListener';
import {getEnvironment} from '@unifocus/js-utils';
import {configureStore} from '@reduxjs/toolkit';

export const reduxPromiseListener: PromiseListener = createReduxPromiseListener();

export declare type ConfigureSagasType<AppState> = (sagaMiddleware: SagaMiddleware<Store<AppState>>) => void;

export const createStandardStore = <AppState, >(reducer: Reducer<AppState, AnyAction>,
                                                configureSagas: ConfigureSagasType<AppState>): Store<AppState, AnyAction> => {
   const sagaMiddleware: SagaMiddleware<Store<AppState>> = createSagaMiddleware();

   const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
                            ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: getEnvironment().applicationId })
                            : compose;

   const store: Store<AppState> = createStore(
      reducer,
      composeEnhancers(applyMiddleware(sagaMiddleware, reduxPromiseListener.middleware))
   );

   configureSagas(sagaMiddleware);

   return store;
};

export const createReduxToolkitStore = <AppState, >(reducer: Reducer<AppState, AnyAction>,
                                                    configureSagas: ConfigureSagasType<AppState>): Store<AppState, AnyAction> => {
   const sagaMiddleware: SagaMiddleware<Store<AppState>> = createSagaMiddleware();
   const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
                            ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: getEnvironment().applicationId })
                            : compose;

   const store = configureStore({
                                   reducer: reducer,
                                   middleware: [
                                      sagaMiddleware,
                                      reduxPromiseListener.middleware
                                   ]
                                });

   configureSagas(sagaMiddleware);

   return store;
};
